var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg3243425404a)" },
      React.createElement("path", { d: "M21.07 2.868H2.935A2.937 2.937 0 0 0 0 5.803v12.394a2.937 2.937 0 0 0 2.935 2.935h18.13A2.937 2.937 0 0 0 24 18.197V5.807a2.934 2.934 0 0 0-2.93-2.94zm1.594 15.33c0 .878-.715 1.593-1.594 1.593H2.935a1.596 1.596 0 0 1-1.594-1.594V5.807c0-.878.715-1.593 1.594-1.593h18.13c.88 0 1.594.715 1.594 1.594v12.39h.005z" }),
      React.createElement("path", { d: "M15.136 11.846l5.87-5.264a.674.674 0 0 0 .05-.948.674.674 0 0 0-.95-.05l-8.094 7.265-1.579-1.41c-.005-.005-.01-.01-.01-.015a.986.986 0 0 0-.109-.094L3.888 5.58a.67.67 0 0 0-.948.054.67.67 0 0 0 .054.948l5.94 5.309-5.915 5.537a.673.673 0 0 0 .919.983l6.004-5.617 1.628 1.455a.67.67 0 0 0 .894-.004l1.674-1.5 5.969 5.67a.67.67 0 0 0 .924-.973l-5.895-5.596z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg3243425404a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })
      )
    )
  );
});